import React, { useEffect, useState } from "react";
import axios from "../../../../Global/axios";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";

const ArrivalListEdit = ({
  EditArrival,
  setArrivalListEdit,
  setUpdateData,
}) => {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const [sumbmitLoading, setSubmitLoading] = useState(false);
  const [applyAll, setApplyAll] = useState(false);
  const [arrivalStatus, setArrivalStatus] = useState(EditArrival?.status);
  const [disable, setDisable] = useState(true);

  const submitHandler = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);

    const arrival_status = e.target.arrival_status.value;
    const select_all = applyAll == true ? "YES" : "NO";

    const body = {
      status: arrival_status,
      apply_for_all_candidates: select_all,
    };
    try {
      const response = await axios.put(`/dashboard/arrival-notification/${EditArrival?.arrivalId}`,
        body,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.status === 200) {
        setSubmitLoading(false);
        dispatch(
          setAppError({ msg: response.data.message, color: "bg-green-600" })
        );
        setUpdateData((prev) => !prev);
        setArrivalListEdit({
          open: false,
          arrivalId: "",
          status: "",
        });
      }
    } catch (e) {
      setSubmitLoading(false);
      dispatch(setAppError({ msg: e.response.data.message }));
    }
  };

  useEffect(() => {
    if (EditArrival?.status != arrivalStatus || applyAll != false) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [arrivalStatus, applyAll]);

  return (
    <form
      onSubmit={submitHandler}
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
        EditArrival?.open ? "flex" : "hidden"
      }`}
    >
      <div className="max-w-2xl w-full h-auto  min-h-[14rem] rounded-md bg-white/90 flex justify-center items-center flex-col">
        <h2 className="text-2xl p-4 pb-1 font-semibold text-center">
          Arrival Notification Edit
        </h2>

        <div className="flex md:flex-row flex-col gap-3 items-center mt-10">
          <label className="font-medium" htmlFor="">
            Select Arrival Status
          </label>
          <select
            required
            className="select select-sm select-bordered"
            name="arrival_status"
            defaultValue={EditArrival?.status}
            id=""
            onChange={(e) => setArrivalStatus(e.target.value)}
          >
            <option value="">select</option>
            <option value="Arrived">Arrived</option>
            <option value="Not Arrived">Not Arrived</option>
          </select>
        </div>
        <div className="mt-6 mb-10 flex items-center justify-center gap-2">
          <input
            name="apply_to_all"
            id="all"
            type="checkbox"
            className="checkbox checkbox-success checkbox-md"
            onChange={(e) => setApplyAll(e.target.checked)}
          />
          <label className="font-semibold text-sm cursor-pointer" htmlFor="all">
            Apply to all candidates in the arrival list
          </label>
        </div>

        <div className="flex gap-3 min-w-fit mt-8 mx-5 mb-5">
          <button
            className={`p-1 w-20 rounded-md ring-1 ring-slate-600`}
            onClick={() => {
              setArrivalListEdit({
                open: false,
                arrivalId: "",
                status: "",
              });
            }}
          >
            Cancel
          </button>
          <button
            disabled={disable}
            type="submit"
            className={` ${
              disable
                ? "cursor-not-allowed opacity-50 p-1 w-fit rounded-md ring-1 ring-red text-white bg-red "
                : "p-1 w-fit rounded-md ring-1 ring-red text-white bg-red"
            }`}
          >
            {sumbmitLoading ? "Submiting.." : "Submit"}
          </button>
        </div>
      </div>
    </form>
  );
};

export default ArrivalListEdit;